module.exports = __webpack_public_path__ + "img/logo.4f59904c.png";